// Shared Leaflet/GeoJSON utilities for map views (OrchardMap, BreederPlantingMap, ...).

export type LatLng = [number, number];

// GeoJSON Polygon stores [lng, lat]; Leaflet wants [lat, lng].
export function geoJSONToLeaflet(coordinates: number[][][]): LatLng[] {
  return coordinates[0].map((coord) => [coord[1], coord[0]] as LatLng);
}

// How far the map is allowed to zoom in. Beyond a provider's own `maxNativeZoom`
// Leaflet upscales the last real tile rather than requesting one that would 404,
// so the extra levels stay usable (slightly soft) for placing pins and tracing
// rows at tree level.
export const MAP_MAX_ZOOM = 22;

export const TILE_LAYERS = {
  street: {
    url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
    attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
    // OSM raster tiles stop at z19.
    maxNativeZoom: 19,
    maxZoom: MAP_MAX_ZOOM,
  },
  satellite: {
    url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
    attribution: 'Tiles &copy; Esri &mdash; Source: Esri, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community',
    // Esri World Imagery serves z20+ in dense areas but drops to z19 (or lower)
    // over rural AU, so 19 is the safe native ceiling.
    maxNativeZoom: 19,
    maxZoom: MAP_MAX_ZOOM,
  },
} as const;

export type TileLayerKey = keyof typeof TILE_LAYERS;
